import { AppState } from '../index';

export const getCartState = (store: AppState) => store.cart;
